import { NgModule } from '@angular/core';
import { MonitorsComponent } from './monitors.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { OverlayPanelModule } from '../overlay-panel/overlay-panel.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MonitorService } from './monitor.service';
@NgModule({
  imports: [
    SharedProviderModule,
    OverlayPanelModule,
    NgbTooltipModule
  ],
  declarations: [MonitorsComponent],
  exports: [MonitorsComponent],
  providers: [MonitorService]
})
export class MonitorsModule {
}
